import { useQuery } from "@tanstack/react-query";
import { getPrescriptionTracking } from "../services/ePrescriptionDetailService";

export const usePrescriptionTracking = (
  prescriptionId?: string,
  token?: string | null
) => {
  return useQuery({
    queryKey: ["prescription-tracking", prescriptionId],
    queryFn: () => getPrescriptionTracking(prescriptionId!, token!),

    enabled: !!prescriptionId && !!token,

    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
  });
};